<script lang="ts" setup>
import { VDatepicker, VIcon } from "@app/core";
import { computed } from "vue";

import { useDatePresets } from "../composables/useDatePresets";

import { useGlobalFiltersSync } from "@/shared/composables/useGlobalFiltersSync";
import { useGlobalFiltersStore } from "@/shared/stores/useGlobalFiltersStore";

// Use date presets composable
const { comparisonPresetDates } = useDatePresets();
const { updateSecondaryInterval } = useGlobalFiltersSync();

// Use global filters store
const filtersStore = useGlobalFiltersStore();

// Create computed with getter/setter for v-model binding
const dateRange = computed({
  get: () => filtersStore.secondaryInterval as [Date, Date],
  set: (value: [Date, Date] | Date[]) => {
    if (!value.some((date: Date) => date === null)) {
      filtersStore.setSecondaryIntervalRange([value[0], value[1]]);
      updateSecondaryInterval();
    }
  },
});
</script>

<template>
  <VDatepicker
    v-model="dateRange"
    :enable-time-picker="false"
    :input-attrs="{ alwaysClearable: false }"
    :preset-dates="comparisonPresetDates"
    :time-config="{ enableTimePicker: false }"
    icon="lucide:arrow-left-right"
    range
    size="md"
    width="230px"
  >
    <template #clear-icon />
    <template #top-extra>
      <div class="pb-3 mb-3 border-b border-cardBorder">
        <div class="flex items-center gap-2 text-base font-semibold text-mainText">
          <VIcon
            icon="lucide:arrow-left-right"
            size="16"
          />
          <span>Comparison Date Range</span>
        </div>
        <div class="mt-1 text-xs font-medium text-secondaryText">
          <slot />
        </div>
      </div>
    </template>
  </VDatepicker>
</template>
